module.exports = __webpack_public_path__ + "static/media/seatPremierOne.pictogram.e29380db.svg";